<script>
export default {
	props: {
		reconocimiento: {
			type: Object,
			required: true
		}
	}
};
</script>

<template>
	<div class="modal fade" id="modal-detalle-colaborador" tabindex="-1">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				


				<div class="close-btn-container modal-header d-flex justify-content-end border-0 p-0">
					<a class="h3 link-secondary" href="javascript:" data-bs-dismiss="modal">
						<font-awesome-icon icon="fa-solid fa-xmark"></font-awesome-icon>
					</a>
				</div>



				<div v-if="Object.keys(reconocimiento).length !== 0" class="modal-body">
					<div class="d-flex mb-3">
						<div class="flex-shrink-0">
							<img v-if="reconocimiento.reconocidos[0].imagen_perfil ||/.jpg|.jpeg|.png/.test(reconocimiento.reconocidos[0].imagen_perfil)"
								width="60"
								height="60"
								class="img-object-cover rounded-circle border border-main p-1"
								:src="reconocimiento.reconocidos[0].imagen_perfil"
							>
							<img v-else
								src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
								width="60"
								height="60"
								class="img-object-cover rounded-circle border border-main p-1"
							/>
						</div>
						<div class="flex-grow-1 ms-3">
							<h4 class="d-grid text-secondary mb-0">
								<strong class="ellipsis-custom">
									{{ capitalizeFirstLetter(reconocimiento.reconocidos[0].primer_nombre) }}
									{{ capitalizeFirstLetter(reconocimiento.reconocidos[0].apellido_paterno) }}
								</strong>
								<span v-if="reconocimiento.reconocidos[0].cargo" class="fs-6 text-secondary text-opacity-75 ellipsis-custom">
									Cargo: {{ reconocimiento.reconocidos[0].cargo[0].nombre_cargo }}
								</span>
								<span v-else class="fs-6 text-secondary text-opacity-75 ellipsis-custom">
									Cargo: sin información
								</span>
							</h4>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-12">
							<h6 class="text-secondary font-700 mb-1">Reconocimiento por</h6>
							<strong class="fs-3 color-main">
								{{ reconocimiento.valor_comportamiento[0].valor.nombre_valor }}
							</strong>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-lg-6">
							<h6 class="text-secondary font-700 mb-0">De</h6>
							<p class="text-secondary text-opacity-75">
								{{ reconocimiento.reconocedor[0].primer_nombre }}
								{{ reconocimiento.reconocedor[0].apellido_paterno }}
							</p>
						</div>
						<div class="col-12 col-lg-6">
							<h6 class="text-secondary font-700 mb-0">Relación</h6>
							<p class="text-secondary text-opacity-75">
								{{ reconocimiento.relacion[0].nombre_relacion }}
							</p>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<p class="text-secondary text-opacity-75">
								{{ reconocimiento.comentario_reconocimiento }}
							</p>
						</div>
					</div>
					<template v-if="reconocimiento.url_imagen">
						<div class="row mt-3">
							<div class="col-12 d-flex justify-content-center">
								<figure class="figure mb-0">
									<img 
										:src="reconocimiento.url_imagen" 
										class="figure-img img-fluid rounded"
									>
								</figure>
							</div>
						</div>
					</template>
				</div>
				<div class="modal-footer">
					<button 
						type="button" 
						class="btn btn-custom btn-custom-line-gray w-100" 
						data-bs-dismiss="modal">
						<font-awesome-icon icon="fa-solid fa-angle-left" class="pe-2"></font-awesome-icon>
						Volver
					</button>
				</div>
			</div>
		</div>
	</div>

</template>

<style>
.close-btn-container {
  display: inline-block;
  width: 4%;
  margin-left: auto;
  position: relative;
  top: 8px;
  right: 17px;
}
</style>